import { useMutation } from 'glimmer-apollo'
import { parse, print } from 'graphql'
import { QUOTE_FRAGMENT } from 'customer-flows/gql/fragments/quote'

export function removeRedemptionCode(
  context: Object,
  variables: RemoveRedemptionCodeInput
): Promise<RemoveRedemptionCodeResponse | undefined | null> {
  return new Promise((resolve, reject) => {
    const removeRedemptionCodeMutation = useMutation<RemoveRedemptionCodeResponse, { input: RemoveRedemptionCodeInput }>(context, () => [
      mutation,
      {
        onError: (error) => {
          reject(new Error('Failed to remove redemption code.', { cause: error }))
        },
        onComplete: (data: RemoveRedemptionCodeResponse | undefined | null) => {
          resolve(data)
        }
      }
    ])

    removeRedemptionCodeMutation.mutate({
      input: variables
    })
  })
}

const mutation = parse(`
  mutation RemoveRedemptionCode($input: RemoveRedemptionCodeInput!) {
    removeRedemptionCode(input: $input) {
      ... on RemoveGiftCardSuccess {
        quote {
          ...QuoteFragment
        }
      }
      ... on RemoveStoreCreditSuccess {
        quote {
          ...QuoteFragment
        }
      }
      ... on RemoveExternalVoucherSuccess {
        quote {
          ...QuoteFragment
        }
      }
      ... on RemovePromoCodeSuccess {
        quote {
          ...QuoteFragment
        }
        warnings
      }
      ... on Error {
        message
      }
    }
  }
  ${print(QUOTE_FRAGMENT)}
`)
